export function getCurrencySymbol(code?: string): string {
  if (!code) return '$';
  const map: Record<string, string> = {
    CAD: '$',
    USD: '$',
    EUR: '€',
    GBP: '£',
    AUD: '$',
    NZD: '$',
    JPY: '¥',
    CHF: 'Fr',
  };
  const upper = code.toUpperCase();
  if (map[upper]) return map[upper];
  try {
    // Try Intl narrowSymbol formatting and extract symbol-only
    const formatted = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: upper,
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(0);
    // Remove digits, minus, decimal separators, spaces
    const sym = formatted.replace(/[0-9\-.,\s]/g, '');
    return sym || upper;
  } catch {
    return upper;
  }
}

export function getCurrencyLabel(code?: string): string {
  if (!code) return '';
  const upper = code.toUpperCase();
  const sym = getCurrencySymbol(upper);
  return sym && sym !== upper ? `${sym} ${upper}` : upper;
}

